import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid";
import { withStyles } from "@material-ui/core/styles";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputBase from "@material-ui/core/InputBase";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import HighlightOffTwoToneIcon from "@material-ui/icons/HighlightOffTwoTone";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import "./styles.css";
import { getLocalidadesEntregaActivas } from "../../sagas/TurneroSaga/calls";

const styles = () => ({
  rootContent: {
    borderRadius: "21px",
    minWidth: "300px",
  },
});
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MENU_PROPS_SELECT_EDIT = {
  getContentAnchorEl: null,
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  disablePortal: true,
  PaperProps: {
    style: { zIndex: 99999, maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP },
  },
};
const MENU_PROPS_SELECT_CREATE = {
  getContentAnchorEl: null,
  anchorOrigin: { vertical: "bottom", horizontal: "left" },
  transformOrigin: { vertical: "top", horizontal: "left" },
  disablePortal: true,
  PaperProps: {
    style: { maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP },
  },
};

class CalendarioConfiguracion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      diaSelected:
        this.props.calendario &&
        this.props.calendario.listaDiasSemana &&
        this.props.calendario.listaDiasSemana.length > 0
          ? this.props.calendario.listaDiasSemana[0]
          : undefined,
      indiceDia:
        this.props.calendario &&
        this.props.calendario.listaDiasSemana &&
        this.props.calendario.listaDiasSemana.length > 0
          ? 0
          : undefined,
      horarioSelected: undefined,
      noLaborableSelected: undefined,
      openModalEliminar: false,
      openModalAltaEdicion: false,
      openModalAltaNoLaborable: false,
      mensaje: "",
      nombreTurno: undefined,
      horaInicio: undefined,
      horaFin: undefined,
      cupo: 0,
      aplicarTodos: false,
      errores: {},
      fechaNoLaborable: undefined,
      fechaNoLaborableConfirmar: undefined,
      porLocalidad: true,
      localidadSeleccionada: null,
      localidadEdicion: null,
      porLocalidadEnEdicion: true,
      localidadesEntregaActivas: [],
    };
  }

  handleTogglePorLocalidad = (event) => {
    this.setState({
      porLocalidad: event.target.checked,
      localidadSeleccionada: "",
    });
  };

  handleChangeLocalidad = (event) => {
    this.setState({
      localidadSeleccionada: event.target.value,
    });
  };

  handleOnClickDia = (dia, indice) => {
    this.setState({ indiceDia: indice, diaSelected: dia });
  };

  handleOnClickElminar = (e, d, h, diaNoLaborable) => {
    e.stopPropagation();
    this.setState({
      openModalEliminar: true,
      diaSelected: d,
      horarioSelected: h,
      noLaborableSelected: diaNoLaborable,
    });
  };

  handleOnBorrarModal = () => {
    if (this.props.esNoLaborable === true) {
      let idCalendarioNoLaborable = this.state.noLaborableSelected.idCalendarioNoLaborable;
      this.setState({ openModalEliminar: false, noLaborableSelected: undefined }, () => {
        this.props.handleOnEliminarCalendarioNoLaborable(idCalendarioNoLaborable);
      });
    } else {
      let idCalendarioHorario = this.state.horarioSelected.idCalendarioHorario;
      this.setState({ openModalEliminar: false, horarioSelected: undefined }, () => {
        this.props.handleOnEliminarCalendarioHorario(idCalendarioHorario);
      });
    }
  };

  handleOnClickHorario = (horario) => {
    const nuevosErrores = { ...this.state.errores };
    delete nuevosErrores.localidadSeleccionada;

    if (horario) {
      let cupo = horario.maxDisponibilidad;
      let horaInicio = horario.horaInicio;
      let horaFin = horario.horaFin;
      let nombre = horario.nombre;
      let localidadEdicion = horario.idLocalidadEntrega ? Number(horario.idLocalidadEntrega) : "";
      let tieneLocalidadEnEdicion = !!horario.idLocalidadEntrega;

      this.setState({
        openModalAltaEdicion: true,
        nombreTurno: nombre,
        horaInicio: horaInicio,
        horaFin: horaFin,
        cupo: cupo,
        horarioSelected: horario,
        localidadEnEdicion: localidadEdicion,
        porLocalidadEnEdicion: tieneLocalidadEnEdicion,
        errores: nuevosErrores,
      });
    } else {
      // MODO ALTA - Validar si está habilitado por localidad y no hay localidad seleccionada
      if (this.props.turneroPorLocalidad && !this.state.localidadSeleccionada) {
        this.setState({
          errores: {
            ...this.state.errores,
            localidadSeleccionada: "Debe seleccionar una localidad antes de agregar un horario",
          },
        });
        return;
      }

      this.setState({
        openModalAltaEdicion: true,
        horarioSelected: undefined,
        horaInicio: "10:00",
        horaFin: "11:00",
        cupo: 0,
        localidadEnEdicion: "",
        porLocalidadEnEdicion: false,
        errores: nuevosErrores,
      });
    }
  };

  handleOnCerrarModal = () => {
    this.setState({
      openModalEliminar: false,
      openModalAltaEdicion: false,
      horarioSelected: undefined,
      noLaborableSelected: undefined,
      nombreTurno: undefined,
      horaInicio: undefined,
      horaFin: undefined,

      cupo: 0,
      aplicarTodos: false,
      localidadEnEdicion: "",
      porLocalidadEnEdicion: false,
    });
  };

  handleOnChangeDataTurno = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "aplicarTodos") {
      value = e.target.checked;
    }

    if (name === "cupo" && value !== "") {
      var letterNumber = /^[0-9]+$/;
      if (value.length > 9 || !value.match(letterNumber)) {
        return;
      }
    }

    this.setState({
      [name]: value,
    });
  };

  handleOnGuardarHorario = () => {
    let errores = {};
    let flag = false;

    if (
      this.state.nombreTurno === undefined ||
      this.state.nombreTurno === null ||
      this.state.nombreTurno === ""
    ) {
      errores.nombreTurno = "Ingrese un nombre para el horario";
      flag = true;
    }

    if (this.state.horaFin === this.state.horaInicio) {
      errores.horaFin = "La hora de fin debe ser mayor que la hora de inicio";
      flag = true;
    }

    if (
      this.state.horaInicio === undefined ||
      this.state.horaInicio === null ||
      this.state.horaInicio === ""
    ) {
      errores.horaInicio = "Ingrese una hora de inicio";
      flag = true;
    }

    if (
      this.state.horaFin === undefined ||
      this.state.horaFin === null ||
      this.state.horaFin === ""
    ) {
      errores.horaFin = "Ingrese una hora de fin";
      flag = true;
    }

    if (
      errores.horaInicio === undefined &&
      errores.horaFin === undefined &&
      this.esMenorIgual(this.state.horaInicio, this.state.horaFin)
    ) {
      errores.horaFin = "La hora de fin debe ser mayor que la hora de inicio";
      flag = true;
    }

    if (this.state.cupo === undefined || this.state.cupo === null || this.state.cupo === "") {
      errores.cupo = "Ingrese el cupo máximo";
      flag = true;
    }

    if (
      this.state.horarioSelected &&
      this.state.porLocalidadEnEdicion &&
      !this.state.localidadEnEdicion
    ) {
      errores.localidadEnEdicion = "Debe seleccionar una localidad";
      flag = true;
    }

    if (flag) {
      this.setState({ errores: errores });
      return;
    }

    let payload = {};
    payload.nombre = this.state.nombreTurno;
    payload.mensaje = this.state.mensaje;
    payload.horaInicio = this.state.horaInicio;
    payload.horaFin = this.state.horaFin;
    payload.cupo = this.state.cupo;
    payload.aplicarTodos = this.state.horarioSelected ? this.state.aplicarTodos : false;
    payload.idCalendarioHorario = this.state.horarioSelected
      ? this.state.horarioSelected.idCalendarioHorario
      : undefined;
    payload.idCalendario = this.state.diaSelected ? this.state.diaSelected.idCalendario : undefined;

    // Determinar qué localidad usar según el modo
    if (this.state.horarioSelected) {
      // MODO EDICIÓN - usar localidad según el checkbox
      payload.idLocalidadEntrega = this.state.porLocalidadEnEdicion
        ? this.state.localidadEnEdicion
        : null;
    } else {
      // MODO ALTA - usar localidad seleccionada si está habilitado por localidad (feature flag)
      payload.idLocalidadEntrega = this.props.turneroPorLocalidad
        ? this.state.localidadSeleccionada
        : null;
    }

    this.setState(
      {
        errores: errores,
        openModalAltaEdicion: false,
        horarioSelected: undefined,
        nombreTurno: undefined,
        horaInicio: undefined,
        horaFin: undefined,
        cupo: 0,
        aplicarTodos: false,
        localidadSeleccionada: this.state.localidadSeleccionada,
        localidadEnEdicion: "",
        porLocalidadEnEdicion: false,
      },
      () => {
        this.props.handleOnSaveTurno(payload);
      }
    );
  };

  esMenorIgual = (inicio, fin) => {
    let hInicio = inicio.split(":");
    let hFin = fin.split(":");

    if (hInicio === undefined || hInicio.length < 2 || hFin === undefined || hFin.length < 2) {
      return true;
    }

    let inicioHora = parseInt(hInicio[0]);
    let inicioMinutos = parseInt(hInicio[1]);
    let finHora = parseInt(hFin[0]);
    let finMinutos = parseInt(hFin[1]);

    if (finHora < inicioHora) {
      return true;
    }

    if (finHora > inicioHora) {
      return false;
    }

    if (finMinutos <= inicioMinutos) {
      return true;
    }
  };

  getLocalidadNombre = (idLocalidad) => {
    if (!idLocalidad) return "";
    const localidad = this.state.localidadesEntregaActivas.find(
      (loc) => loc.idLocalidadEntrega === idLocalidad
    );
    return localidad ? localidad.descripcion : "";
  };

  handleChangeLocalidadEdicion = (event) => {
    const value = event.target.value === "" ? "" : Number(event.target.value);
    this.setState({
      localidadEnEdicion: value,
    });
  };

  handleTogglePorLocalidadEnEdicion = (event) => {
    const checked = event.target.checked;
    this.setState((prev) => ({
      porLocalidadEnEdicion: checked,
      localidadEnEdicion: checked
        ? prev.localidadEnEdicion !== null && prev.localidadEnEdicion !== ""
          ? Number(prev.localidadEnEdicion)
          : prev.horarioSelected?.idLocalidadEntrega
            ? Number(prev.horarioSelected.idLocalidadEntrega)
            : ""
        : null,
    }));
  };

  handleOnClickAgregarNoLaborable = () => {
    let openModalAltaNoLaborable = !this.state.openModalAltaNoLaborable;

    this.setState({
      openModalAltaNoLaborable: openModalAltaNoLaborable,
      fechaNoLaborable: undefined,
      fechaNoLaborableConfirmar: undefined,
    });
  };

  handleOnChangeDate = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    this.setState({
      [name]: value,
    });
  };
  handleOnChangeMsg = (e) => {
    let mensaje = e.target.name;
    let value = e.target.value;
    this.setState({
      [mensaje]: value,
    });
  };

  handleOnGuardarNoLaborable = () => {
    let errores = {};
    let flag = false;

    if (this.state.fechaNoLaborable === undefined) {
      errores.fechaNoLaborable = "Seleccione una fecha";
      flag = true;
    }

    if (this.state.fechaNoLaborableConfirmar === undefined) {
      errores.fechaNoLaborableConfirmar = "Seleccione una fecha";
      flag = true;
    }

    if (this.state.mensaje.trim().length === 0) {
      errores.mensaje = "Ingrese un mensaje";
      flag = true;
    }

    if (
      this.state.fechaNoLaborable !== undefined &&
      this.state.fechaNoLaborableConfirmar !== undefined &&
      this.state.fechaNoLaborable !== this.state.fechaNoLaborableConfirmar
    ) {
      errores.fechaNoLaborableConfirmar = "Las fechas seleccionadas no coinciden";
      flag = true;
    }

    if (flag) {
      this.setState({ errores: errores });
      return;
    }

    let payload = {};
    payload.fecha = this.state.fechaNoLaborable;
    payload.mensaje = this.state.mensaje;

    this.setState(
      {
        errores: errores,
        openModalAltaNoLaborable: false,
      },
      () => {
        this.props.handleOnSaveCalendarioNoLaborable(payload);
      }
    );
  };

  async componentDidMount() {
    try {
      const localidades = await getLocalidadesEntregaActivas();
      this.setState({
        localidadesEntregaActivas: localidades,
      });
    } catch (error) {
      this.setState({ mensaje: "Error al cargar las localidades" });
    }
  }
  render() {
    const { classes } = this.props;
    const modalidad = this.props.calendario.nombre ? this.props.calendario.nombre : "";
    const mostrarLocalidad =
      !this.props.esNoLaborable &&
      modalidad === "Delivery" &&
      this.props.turneroPorLocalidad === true;
    return (
      <div className="containerTurneroConfig">
        {/* Checkbox para habilitar turnos por localidad solo si es config delivery con feature flag */}
        {mostrarLocalidad && (
          <>
            <div
              style={{
                marginBottom: "15px",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {/* <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.porLocalidad}
                                    // onChange={this.handleTogglePorLocalidad}
                                    name="porLocalidad"
                                    color="primary"
                                />
                            }
                            label="Agregar turno por localidad"
                            style={{marginLeft: 0}}
                        /> */}
              {this.state.porLocalidad && (
                <FormControl
                  className={classes.formControl}
                  variant="outlined"
                  style={{ marginTop: 0, marginLeft: 20 }}
                >
                  <InputLabel id="localidad-label" shrink={!!this.state.localidadSeleccionada}>
                    Localidad
                  </InputLabel>
                  <Select
                    labelId="localidad-label"
                    value={this.state.localidadSeleccionada}
                    onChange={this.handleChangeLocalidad}
                    error={!!this.state.errores.localidadSeleccionada}
                    MenuProps={MENU_PROPS_SELECT_CREATE}
                    label="Localidad"
                    style={{ minWidth: "200px", maxWidth: "300px" }}
                  >
                    {this.state.localidadesEntregaActivas.map((localidad) => (
                      <MenuItem
                        key={localidad.idLocalidadEntrega}
                        value={localidad.idLocalidadEntrega}
                      >
                        {localidad.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                  {this.state.errores.localidadSeleccionada && (
                    <FormHelperText error>
                      {this.state.errores.localidadSeleccionada}
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            </div>
            {this.state.localidadSeleccionada && (
              <>
                {/* DIAS DISPONIBLES */}
                {!this.props.esNoLaborable && (
                  <div className="containerOptionsDias">
                    {this.props.calendario &&
                      this.props.calendario.listaDiasSemana &&
                      this.props.calendario.listaDiasSemana.length > 0 &&
                      this.props.calendario.listaDiasSemana.map((ds, indice) => {
                        return (
                          <div
                            key={ds.idCalendario || ds.diaNombre}
                            className={`itemDia ${this.state.indiceDia === indice ? "active" : ""}`}
                            onClick={() => this.handleOnClickDia(ds, indice)}
                          >
                            <div
                              className={`diaNumero ${this.state.indiceDia === indice ? "activeDiaNumero" : ""}`}
                            >
                              {ds.diaNombre.substring(0, 1)}
                            </div>
                            <div
                              className={`diaNombre ${this.state.indiceDia === indice ? "activeDiaNombre" : ""}`}
                            >
                              {ds.diaNombre}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                )}

                {/* Mensaje info */}
                {!this.props
                  .esNoLaborable /*&& this.props.calendario && this.props.calendario.listaDiasSemana && this.props.calendario.listaDiasSemana.length > 0*/ && (
                  <Row>
                    <Col md={12}>
                      <div className="infoCalendario">
                        <InfoOutlinedIcon />
                        <div>Los horarios se ordenan por hora de inicio</div>
                      </div>
                    </Col>
                  </Row>
                )}

                {/* HORARIOS DISPONIBLES */}
                {!this.props.esNoLaborable ? (
                  /* HORARIOS CALENDARIO */
                  <div className="containerOptionsHorarios">
                    {this.state.indiceDia !== undefined &&
                      this.props.calendario &&
                      this.props.calendario.listaDiasSemana &&
                      this.props.calendario.listaDiasSemana.length > 0 &&
                      this.props.calendario.listaDiasSemana[this.state.indiceDia]
                        .listaCalendarioHorarios &&
                      (() => {
                        // Filtrar horarios por localidad
                        const horariosFiltrados = this.props.calendario.listaDiasSemana[
                          this.state.indiceDia
                        ].listaCalendarioHorarios.filter(
                          (horario) =>
                            horario.idLocalidadEntrega === this.state.localidadSeleccionada
                        );

                        // Si no hay horarios, mostrar alerta
                        if (horariosFiltrados.length === 0) {
                          return (
                            <div
                              className={`itemAlertHorario`}
                              style={{
                                padding: "12px 16px",
                                backgroundColor: "#e3f2fd",
                                border: "1px solid #2196f3",
                                borderRadius: "4px",
                                color: "#1976d2",
                                marginBottom: "16px",
                                display: "flex",
                                alignItems: "center",
                                fontSize: "14px",
                              }}
                            >
                              <InfoOutlinedIcon
                                style={{
                                  marginRight: "8px",
                                  fontSize: "20px",
                                  color: "#1976d2",
                                }}
                              />
                              <span>
                                No hay horarios disponibles para este día en la localidad
                                seleccionada.
                              </span>
                            </div>
                          );
                        }

                        // Si hay horarios, mostrarlos
                        return horariosFiltrados.map((h) => {
                          return (
                            <div
                              key={h.idCalendarioHorario}
                              className={`itemHorario`}
                              onClick={() => this.handleOnClickHorario(h)}
                            >
                              <div className="horario">{`${h.nombre} (${h.maxDisponibilidad})`}</div>
                              <HighlightOffTwoToneIcon
                                onClick={(e) =>
                                  this.handleOnClickElminar(
                                    e,
                                    this.props.calendario.listaDiasSemana[this.state.indiceDia],
                                    h
                                  )
                                }
                                className="iconDelete"
                              />
                            </div>
                          );
                        });
                      })()}

                    <div
                      className={`itemHorario itemAgregar`}
                      onClick={() => this.handleOnClickHorario(undefined)}
                    >
                      <div className="horario">AGREGAR</div>
                    </div>
                  </div>
                ) : (
                  // <div className='containerOptionsHorarios'>

                  //     {this.state.indiceDia !== undefined && this.props.calendario && this.props.calendario.listaDiasSemana && this.props.calendario.listaDiasSemana.length > 0 &&
                  //     (this.props.calendario.listaDiasSemana[this.state.indiceDia].listaCalendarioHorarios !== undefined && this.props.calendario.listaDiasSemana[this.state.indiceDia].listaCalendarioHorarios !== null) &&
                  //     this.props.calendario.listaDiasSemana[this.state.indiceDia].listaCalendarioHorarios.map((h, i) => {
                  //         return <div className={`itemHorario`} onClick={() => this.handleOnClickHorario(h)}>
                  //                     <div className='horario'>{`${h.nombre} (${h.maxDisponibilidad})`}</div>
                  //                     <HighlightOffTwoToneIcon onClick={(e) => this.handleOnClickElminar(e,this.props.calendario.listaDiasSemana[this.state.indiceDia], h)} className='iconDelete'/>
                  //                 </div>
                  //     })}

                  //     <div className={`itemHorario itemAgregar`} onClick={() => this.handleOnClickHorario(undefined)}>
                  //         <div className='horario'>AGREGAR</div>
                  //     </div>

                  // </div>
                  /* DIAS NO LABORABLES */
                  <div className="containerOptionsHorarios">
                    {this.props.calendario &&
                      this.props.calendario.diasNoLaborables &&
                      this.props.calendario.diasNoLaborables.length > 0 &&
                      this.props.calendario.diasNoLaborables.map((d) => {
                        return (
                          <div key={d.idCalendarioNoLaborable || d.fecha} className={`itemHorario`}>
                            <div className="horario">{d.fecha}</div>
                            <HighlightOffTwoToneIcon
                              onClick={(e) => this.handleOnClickElminar(e, undefined, undefined, d)}
                              className="iconDelete"
                            />
                          </div>
                        );
                      })}

                    <div
                      className={`itemHorario itemAgregar`}
                      onClick={this.handleOnClickAgregarNoLaborable}
                    >
                      <div className="horario">AGREGAR</div>
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
        {!mostrarLocalidad && (
          <>
            {/* DIAS DISPONIBLES */}
            {!this.props.esNoLaborable && (
              <div className="containerOptionsDias">
                {this.props.calendario &&
                  this.props.calendario.listaDiasSemana &&
                  this.props.calendario.listaDiasSemana.length > 0 &&
                  this.props.calendario.listaDiasSemana.map((ds, indice) => {
                    return (
                      <div
                        key={ds.idCalendario || ds.diaNombre}
                        className={`itemDia ${this.state.indiceDia === indice ? "active" : ""}`}
                        onClick={() => this.handleOnClickDia(ds, indice)}
                      >
                        <div
                          className={`diaNumero ${this.state.indiceDia === indice ? "activeDiaNumero" : ""}`}
                        >
                          {ds.diaNombre.substring(0, 1)}
                        </div>
                        <div
                          className={`diaNombre ${this.state.indiceDia === indice ? "activeDiaNombre" : ""}`}
                        >
                          {ds.diaNombre}
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}

            {/* Mensaje info */}
            {!this.props
              .esNoLaborable /*&& this.props.calendario && this.props.calendario.listaDiasSemana && this.props.calendario.listaDiasSemana.length > 0*/ && (
              <Row>
                <Col md={12}>
                  <div className="infoCalendario">
                    <InfoOutlinedIcon />
                    <div>Los horarios se ordenan por hora de inicio</div>
                  </div>
                </Col>
              </Row>
            )}

            {/* HORARIOS DISPONIBLES */}
            {!this.props.esNoLaborable ? (
              /* HORARIOS CALENDARIO */
              <div className="containerOptionsHorarios">
                {this.state.indiceDia !== undefined &&
                  this.props.calendario &&
                  this.props.calendario.listaDiasSemana &&
                  this.props.calendario.listaDiasSemana.length > 0 &&
                  this.props.calendario.listaDiasSemana[this.state.indiceDia]
                    .listaCalendarioHorarios !== undefined &&
                  this.props.calendario.listaDiasSemana[this.state.indiceDia]
                    .listaCalendarioHorarios !== null &&
                  this.props.calendario.listaDiasSemana[
                    this.state.indiceDia
                  ].listaCalendarioHorarios.map((h) => {
                    return (
                      <div
                        key={h.idCalendarioHorario}
                        className={`itemHorario`}
                        onClick={() => this.handleOnClickHorario(h)}
                      >
                        <div className="horario">{`${h.nombre} (${h.maxDisponibilidad})`}</div>
                        <HighlightOffTwoToneIcon
                          onClick={(e) =>
                            this.handleOnClickElminar(
                              e,
                              this.props.calendario.listaDiasSemana[this.state.indiceDia],
                              h
                            )
                          }
                          className="iconDelete"
                        />
                      </div>
                    );
                  })}

                <div
                  className={`itemHorario itemAgregar`}
                  onClick={() => this.handleOnClickHorario(undefined)}
                >
                  <div className="horario">AGREGAR</div>
                </div>
              </div>
            ) : (
              /* DIAS NO LABORABLES */
              <div className="containerOptionsHorarios">
                {this.props.calendario &&
                  this.props.calendario.diasNoLaborables &&
                  this.props.calendario.diasNoLaborables.length > 0 &&
                  this.props.calendario.diasNoLaborables.map((d) => {
                    return (
                      <div key={d.idCalendarioNoLaborable || d.fecha} className={`itemHorario`}>
                        <div className="horario">{d.fecha}</div>
                        <HighlightOffTwoToneIcon
                          onClick={(e) => this.handleOnClickElminar(e, undefined, undefined, d)}
                          className="iconDelete"
                        />
                      </div>
                    );
                  })}

                <div
                  className={`itemHorario itemAgregar`}
                  onClick={this.handleOnClickAgregarNoLaborable}
                >
                  <div className="horario">AGREGAR</div>
                </div>
              </div>
            )}
          </>
        )}

        {/* MODAL eliminacion turno */}
        {
          <Dialog
            classes={{ paperScrollPaper: classes.rootContent }}
            open={this.state.openModalEliminar}
            onClose={this.handleOnCerrarModal}
            disableBackdropClick={false}
            disableEscapeKeyDown={false}
            ModalProps={{ disableEnforceFocus: true }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogContent className="containerModalEliminarTurno">
              <DialogContentText id="alert-dialog-description">
                {this.props.esNoLaborable ? (
                  <div className="textDescripcion">
                    {`Esta por eliminar la fecha "${this.state.noLaborableSelected ? this.state.noLaborableSelected.fecha : ""}". Desea continuar?`}
                  </div>
                ) : (
                  <div className="textDescripcion">
                    {`Esta por eliminar el horario "${this.state.horarioSelected ? this.state.horarioSelected.nombre : ""}" del día "${this.state.diaSelected ? this.state.diaSelected.diaNombre : ""}". Desea continuar?`}
                  </div>
                )}
              </DialogContentText>

              <DialogActions style={{ justifyContent: "center", marginTop: "30px" }}>
                <Button
                  onClick={this.handleOnCerrarModal}
                  className="btnModalTope btnCerrar"
                  autoFocus
                >
                  CERRAR
                </Button>
                <Button onClick={this.handleOnBorrarModal} className="btnModalTope">
                  BORRAR
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        }

        {/* MODAL ALTA/ELIMINACION TURNO */}
        {
          <Dialog
            classes={{ paperScrollPaper: classes.rootContent }}
            open={this.state.openModalAltaEdicion}
            onClose={this.handleOnCerrarModal}
            disableBackdropClick={false}
            disableEscapeKeyDown={false}
            ModalProps={{ disableEnforceFocus: true }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogContent className="modalAltaEdicionTurno">
              <Row style={{ margin: "0px" }}>
                <div className="containerModalAltaEdicionTurno">
                  <div className="labelTitle">Completa los siguientes datos</div>

                  {this.state.horarioSelected ? (
                    // MODO EDICIÓN - Mostrar checkbox y selector de localidad
                    <div className="localidadEdicionContainer" style={{ marginBottom: "15px" }}>
                      {this.state.horarioSelected.idLocalidadEntrega && (
                        <div
                          className="localidadActualInfo"
                          style={{
                            backgroundColor: "#e8f5e8",
                            padding: "10px",
                            borderRadius: "5px",
                            marginBottom: "10px",
                            border: "1px solid #4caf50",
                          }}
                        >
                          <span className="label" style={{ fontWeight: "bold", color: "#388e3c" }}>
                            Localidad actual:{" "}
                            {this.getLocalidadNombre(this.state.horarioSelected.idLocalidadEntrega)}
                          </span>
                        </div>
                      )}

                      {/* Checkbox para habilitar edición por localidad */}
                      {/* <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={this.state.porLocalidadEnEdicion}
                                                    onChange={this.handleTogglePorLocalidadEnEdicion}
                                                    name="porLocalidadEnEdicion"
                                                    color="primary"
                                                />
                                            }
                                            label="Asignar a localidad específica"
                                            style={{marginLeft: 0, marginBottom: '10px'}}
                                        /> */}

                      {/* Selector de localidad en edición */}
                      {this.state.porLocalidadEnEdicion && (
                        <FormControl
                          className={classes.formControl}
                          variant="outlined"
                          style={{ marginTop: 0, minWidth: "100%" }}
                        >
                          <InputLabel id="localidad-edicion-label">Localidad</InputLabel>
                          <Select
                            labelId="localidad-edicion-label"
                            value={
                              this.state.localidadEnEdicion === null
                                ? ""
                                : this.state.localidadEnEdicion
                            }
                            onChange={this.handleChangeLocalidadEdicion}
                            MenuProps={MENU_PROPS_SELECT_EDIT}
                            error={!!this.state.errores.localidadEnEdicion}
                            label="Localidad"
                          >
                            {this.state.localidadesEntregaActivas.map((localidad) => (
                              <MenuItem
                                key={localidad.idLocalidadEntrega}
                                value={Number(localidad.idLocalidadEntrega)}
                              >
                                {localidad.descripcion}
                              </MenuItem>
                            ))}
                          </Select>
                          {this.state.errores.localidadEnEdicion && (
                            <FormHelperText error>
                              {this.state.errores.localidadEnEdicion}
                            </FormHelperText>
                          )}
                        </FormControl>
                      )}
                    </div>
                  ) : (
                    // MODO ALTA - Mostrar localidad seleccionada si está habilitado por localidad
                    this.props.turneroPorLocalidad &&
                    this.state.localidadSeleccionada && (
                      <div
                        className="localidadInfo"
                        style={{
                          backgroundColor: "#f5f5f5",
                          padding: "10px",
                          borderRadius: "5px",
                          marginBottom: "15px",
                          border: "1px solid #ddd",
                        }}
                      >
                        <span className="label" style={{ fontWeight: "bold" }}>
                          Localidad seleccionada:{" "}
                          {this.getLocalidadNombre(this.state.localidadSeleccionada)}
                        </span>
                      </div>
                    )
                  )}

                  <div className="containerForm">
                    <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                      <div className="inputContainer">
                        <span className="label">Nombre</span>
                        <InputBase
                          placeholder="Nombre"
                          value={this.state.nombreTurno}
                          name="nombreTurno"
                          onChange={this.handleOnChangeDataTurno}
                          error={this.state.errores.nombreTurno !== undefined}
                        />
                        {this.state.errores.nombreTurno !== undefined && (
                          <FormHelperText error style={{ marginTop: "3px" }}>
                            {this.state.errores.nombreTurno}
                          </FormHelperText>
                        )}
                      </div>
                    </Col>

                    <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                      <div className="containerHoras">
                        <div className="inputContainer" style={{ marginRight: "10px" }}>
                          <span className="label">Hora inicio</span>
                          <TextField
                            className="currencyInput"
                            name="horaInicio"
                            type="time"
                            defaultValue={this.state.horaInicio}
                            onChange={this.handleOnChangeDataTurno}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 300, // 5 min
                            }}
                          />
                          {this.state.errores.horaInicio !== undefined && (
                            <FormHelperText error style={{ marginTop: "3px" }}>
                              {this.state.errores.horaInicio}
                            </FormHelperText>
                          )}
                        </div>

                        <div className="inputContainer">
                          <span className="label">Hora fin</span>
                          <TextField
                            className="currencyInput"
                            name="horaFin"
                            type="time"
                            defaultValue={this.state.horaFin}
                            onChange={this.handleOnChangeDataTurno}
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              step: 300, // 5 min
                            }}
                          />
                          {this.state.errores.horaFin !== undefined && (
                            <FormHelperText error style={{ marginTop: "3px" }}>
                              {this.state.errores.horaFin}
                            </FormHelperText>
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                      <div className="aplicarTodos">
                        <div className="inputContainer">
                          <span className="label">Cupo</span>
                          <InputBase
                            placeholder="Cupo"
                            value={this.state.cupo}
                            name="cupo"
                            onChange={this.handleOnChangeDataTurno}
                            error={this.state.errores.cupo !== undefined}
                          />
                          {this.state.errores.cupo !== undefined && (
                            <FormHelperText error style={{ marginTop: "3px" }}>
                              {this.state.errores.cupo}
                            </FormHelperText>
                          )}
                        </div>

                        {this.state.horarioSelected !== undefined && (
                          <div className="containerCheckEntrega">
                            <Checkbox
                              onChange={this.handleOnChangeDataTurno}
                              name="aplicarTodos"
                              checked={this.state.aplicarTodos}
                            />
                            <div className="textLabel">Aplicar a todos los horarios del día</div>
                          </div>
                        )}
                      </div>
                    </Col>
                  </div>
                </div>
              </Row>

              <DialogActions style={{ justifyContent: "center", marginTop: "30px" }}>
                <Button
                  onClick={this.handleOnCerrarModal}
                  className="btnModalTope btnCerrar"
                  autoFocus
                >
                  CERRAR
                </Button>
                <Button onClick={this.handleOnGuardarHorario} className="btnModalTope">
                  GUARDAR
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        }

        {/* MODAL eliminacion turno */}
        {
          <Dialog
            classes={{ paperScrollPaper: classes.rootContent }}
            open={this.state.openModalAltaNoLaborable}
            onClose={this.handleOnClickAgregarNoLaborable}
            disableBackdropClick={false}
            disableEscapeKeyDown={false}
            ModalProps={{ disableEnforceFocus: true }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="sm"
            fullWidth={true}
          >
            <DialogContent className="containerModalEliminarTurno">
              <DialogContentText id="alert-dialog-description">
                <div className="textDescripcion">Ingrese y confirme una fecha</div>
              </DialogContentText>

              <Col xs={12}>
                <div className="containerFechasNoLaborables">
                  <div>
                    <TextField
                      className="currencyInput"
                      name="fechaNoLaborable"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onChange={this.handleOnChangeDate}
                    />
                    {this.state.errores.fechaNoLaborable !== undefined && (
                      <FormHelperText error style={{ marginTop: "3px", marginBottom: "10px" }}>
                        {this.state.errores.fechaNoLaborable}
                      </FormHelperText>
                    )}
                  </div>

                  <div>
                    <TextField
                      className="currencyInput"
                      name="fechaNoLaborableConfirmar"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      onChange={this.handleOnChangeDate}
                    />
                    {this.state.errores.fechaNoLaborableConfirmar !== undefined && (
                      <FormHelperText error style={{ marginTop: "3px" }}>
                        {this.state.errores.fechaNoLaborableConfirmar}
                      </FormHelperText>
                    )}
                  </div>

                  <div className="containerModalAltaEdicionTurno">
                    <div className="containerForm">
                      <div className="aplicarTodos">
                        <div className="inputContainer">
                          <Col xs={12} md={12} lg={12} style={{ padding: "0px" }}>
                            <span className="label">Mensaje Al Público</span>
                            <TextField
                              className="currencyInput"
                              name="mensaje"
                              type="text"
                              inputProps={{
                                maxLength: 255,
                                style: { textAlign: "center", height: "45px", width: "234px" },
                              }}
                              placeholder="Ingrese Mensaje"
                              onChange={this.handleOnChangeMsg}
                            />
                            {this.state.errores.mensaje !== undefined && (
                              <FormHelperText error style={{ marginTop: "3px" }}>
                                {this.state.errores.mensaje}
                              </FormHelperText>
                            )}
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <DialogActions style={{ justifyContent: "center", marginTop: "30px" }}>
                <Button
                  onClick={this.handleOnClickAgregarNoLaborable}
                  className="btnModalTope btnCerrar"
                  autoFocus
                >
                  CERRAR
                </Button>
                <Button onClick={this.handleOnGuardarNoLaborable} className="btnModalTope">
                  GUARDAR
                </Button>
              </DialogActions>
            </DialogContent>
          </Dialog>
        }
      </div>
    );
  }
}

CalendarioConfiguracion.defaultProps = {
  calendario: [],
  esNoLaborable: false,
  turneroPorLocalidad: false,
  handleOnSaveTurno: (f) => f,
  handleOnEliminarCalendarioHorario: (f) => f,
  handleOnEliminarCalendarioNoLaborable: (f) => f,
  handleOnSaveCalendarioNoLaborable: (f) => f,
};

CalendarioConfiguracion.propTypes = {
  calendario: PropTypes.array.isRequired,
  esNoLaborable: PropTypes.bool.isRequired,
  turneroPorLocalidad: PropTypes.bool,
  handleOnSaveTurno: PropTypes.func.isRequired,
  handleOnEliminarCalendarioHorario: PropTypes.func.isRequired,
  handleOnEliminarCalendarioNoLaborable: PropTypes.func.isRequired,
  handleOnSaveCalendarioNoLaborable: PropTypes.func.isRequired,
};

export default withStyles(styles)(CalendarioConfiguracion);
